var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    fill: "none",
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.5047 53.0095C41.1429 53.0095 53.0095 41.1429 53.0095 26.5047C53.0095 11.8666 41.1429 0 26.5047 0C11.8666 0 0 11.8666 0 26.5047C0 41.1429 11.8666 53.0095 26.5047 53.0095Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_162_872)",
    d: "M27.512 29.7913L36.7356 13.8354L41.7185 16.698C44.9521 18.5533 46.0653 22.688 44.21 25.9746L39.015 34.9332C37.8488 36.9476 35.3044 37.6367 33.237 36.4705L28.5722 33.767C27.1409 33.0249 26.6638 31.2226 27.512 29.7913Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDBD00",
    d: "M26.5047 18.7123L15.1077 38.5909L20.0906 41.4534C23.3241 43.3087 27.4589 42.2485 29.3672 38.9619L36.7355 26.0806C37.9017 24.0663 37.2126 21.4688 35.1983 20.3026L30.5864 17.5991C29.1552 16.857 27.3529 17.2811 26.5047 18.7123Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2DA94F",
    d: "M36.6827 13.8354L33.131 11.8211C29.0493 9.48866 23.9074 10.8669 21.575 14.8956L15.0018 26.2927C13.8356 28.307 14.5247 30.9045 16.5391 32.0707L20.0907 34.0851C22.1051 35.2513 24.7025 34.5621 25.8687 32.5478L33.7141 18.9243C35.3574 16.0618 38.9621 15.1607 41.7716 16.751"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_162_872)",
    d: "M22.635 18.2352L18.7123 15.9558C16.963 14.9486 14.7366 15.5317 13.7294 17.2811L9.06456 25.3915C6.73215 29.3672 8.11039 34.5091 12.0861 36.7886L15.0546 38.4849L18.6593 40.5522L20.2496 41.4534C17.4401 39.5981 16.5919 35.8344 18.2882 32.9189L19.5074 30.7985L23.9602 23.1121C24.9674 21.4688 24.3313 19.2424 22.635 18.2352Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_162_872",
    x1: 29.823,
    x2: 43.484,
    y1: 23.319,
    y2: 28.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D93025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EA4335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_162_872",
    x1: 9.09,
    x2: 24.307,
    y1: 24.906,
    y2: 30.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#4285F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#1B74E8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePay);
export default __webpack_public_path__ + "static/media/google_pay.8c039c08dcf7cf3ddc33eca9a4a86432.svg";
export { ForwardRef as ReactComponent };